import { onMounted, onBeforeUnmount } from 'vue';

export const useEscapePress = (handler) => {
    const onKeydown = (e) => {
        if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
            handler(e);
        }
    };

    onMounted(() => {
        document.addEventListener('keydown', onKeydown);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('keydown', onKeydown);
    });
};
